// Copyright (c) Ping. All rights reserved.
//
// invite-flow Wave-2C — thin web host. Routes the /leaderboard tab
// through the shared `LeaderboardScreen` (NativeWind boundary in
// `packages/ui/src/leaderboard/`). The load/subscribe adapters
// remain stubs pending the BE wiring slice.

import { LeaderboardScreen } from '@ping/ui';

export function LeaderboardRouteHost(): JSX.Element {
  return (
    <LeaderboardScreen
      initialBoardId={null}
      loadBoard={async () => ({
        id: 'stub' as never,
        title: 'Leaderboard',
        columns: [],
        entries: [],
      })}
      subscribeBoard={() => () => {}}
      loadTemplates={async () => []}
    />
  );
}
